module.exports = __webpack_public_path__ + "img/slide8_vn.57ff75f4.jpg";